module.exports = __webpack_public_path__ + "components/panel/ski-bro/static/swiss@3-5edc5f92809a24b343331f0ccf6f1e7b.jpg";